var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9925_14622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.75 6.68945V25.9775L25.9775 31.75H6.68945L0.916992 25.9775V6.68945L6.68945 0.916992H25.9775L31.75 6.68945ZM8.33301 30.25H24.3418L21.2422 25.083H11.4746L8.33301 30.25ZM2.87598 25.8154L6.85449 29.7939L10.085 24.4785L8.21777 22.6113L2.87598 25.8154ZM22.6104 24.4482L25.8154 29.79L29.79 25.8154L24.4473 22.6104L22.6104 24.4482ZM2.41699 24.3418L7.58301 21.2422V11.4502L2.41699 8.7041V24.3418ZM25.083 11.4248V21.2412L30.25 24.3418V8.32422L25.083 11.4248ZM9.08301 11.3105V21.3555L11.3105 23.583H21.3555L23.583 21.3555V11.3105L21.3555 9.08301H11.3105L9.08301 11.3105ZM2.61523 7.11133L8.19531 10.0762L10.0762 8.19531L7.11133 2.61523L2.61523 7.11133ZM22.6113 8.21777L24.4482 10.0547L29.79 6.85059L25.8154 2.87598L22.6113 8.21777ZM11.4502 7.58301H21.2422L24.3418 2.41699H8.70508L11.4502 7.58301Z",
    fill: "#F9F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9925_14622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVip);
export default __webpack_public_path__ + "static/media/vip.03785d586d92ebbeb66d3fc5c45e094f.svg";
export { ForwardRef as ReactComponent };